// Art system for the cartoon Neapolitan deck (v2).
// Numerals (2..7) are composed from a single suit icon; ace (1) and figures
// (8,9,10) use a dedicated illustration. All served locally as transparent PNGs.
export const ICON = {
  denari: '/cards/v2/icon-denari.png',
  coppe: '/cards/v2/icon-coppe.png',
  spade: '/cards/v2/icon-spade.png',
  bastoni: '/cards/v2/icon-bastoni.png',
};

// v3: full self-contained card images (frame/border baked in).
export const artUrl = (suit, value) => `/cards/v3/${suit}-${value}.png`;

// Card aspect ratio of the provided v3 assets (94 x 145).
export const CARD_ASPECT = '94/145';

// Card back reuses the Napoli home artwork, cropped to card proportions.
export const CARD_BACK = '/images/home-bg.jpeg';

// Tall, narrow icons (need a taller/narrower box).
export const TALL = { spade: true, bastoni: true };

// Center points (percent of the useful area) per pip count. Clean grid.
export const POS = {
  2: [[50, 28], [50, 72]],
  3: [[50, 20], [50, 50], [50, 80]],
  4: [[28, 28], [72, 28], [28, 72], [72, 72]],
  5: [[28, 27], [72, 27], [50, 50], [28, 73], [72, 73]],
  6: [[29, 21], [71, 21], [29, 50], [71, 50], [29, 79], [71, 79]],
  7: [[29, 19], [71, 19], [29, 50], [71, 50], [29, 81], [71, 81], [50, 50]],
};

// Icon box base size (% of useful width) per count — bigger on low cards.
export const BASE = { 2: 48, 3: 42, 4: 40, 5: 38, 6: 35, 7: 33 };
